var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-stepper-section',{attrs:{"label":""}},[_c('vue-tags-input',{staticClass:"tag",attrs:{"add-only-from-autocomplete":true,"tags":_vm.tags,"placeholder":"Tags","autocomplete-items":_vm.filteredItems},on:{"tags-changed":newTags => _vm.tags = newTags},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }